// El Personaje Alpha.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Personaje Alpha ----

// Facturación (Stripe Payment Links) + plan Familiar.
export const getBillingConfig = async () => (await api.get("/billing/config")).data;
export const startCheckout = async (plan, cycle = "monthly") =>
  (await api.get(`/billing/checkout?plan=${plan}&cycle=${cycle}`)).data;
export const getBillingPortal = async () => (await api.get("/billing/portal")).data;
// EL ENLACE PARA CASA (B3.1). El alumno lo genera con su sesion; las otras tres las llama la
// pagina `/pagar`, que abre un adulto SIN sesion: lo unico que viaja es el token del enlace, y
// el plan se abre en la cuenta del alumno que va dentro, nunca en la de quien pulsa.
export const generaEnlaceParaCasa = async () => (await api.post("/billing/enlace")).data;
export const leeEnlaceParaCasa = async (t) =>
  (await api.get("/billing/enlace", { params: { t } })).data;
export const pagaDesdeElEnlace = async (t, plan, cycle) =>
  (await api.get("/billing/enlace/pagar", { params: { t, plan, cycle } })).data;
export const pidePermisoDesdeElEnlace = async (t, email) =>
  (await api.post("/billing/enlace/permiso", null, { params: { t, email } })).data;
export const getFamily = async () => (await api.get("/family")).data;
export const sendFamilyInvites = async (emails) => (await api.post("/family/invites", { emails })).data;
export const removeFamilyInvite = async (email) => (await api.post("/family/invites/remove", { email })).data;
// La pulsa la persona INVITADA desde su correo: no hay sesión, solo el token del enlace.
// Invitar a una cuenta que ya existe no la enlaza; la enlaza esto, que es un acto suyo.
export const confirmaInvitacion = async (t) =>
  (await api.get("/family/invitacion/confirmar", { params: { t } })).data;

// Centro de Recompensas: logros + recursos desbloqueables.
export const getLogros = async () => (await api.get("/logros")).data;

// Los titulos: la forma lucible de un logro. `ponerTitulo` puede fallar con 403 si el
// alumno no lo tiene ganado, y eso NO es un error a esconder: es la regla. Quien llame
// tiene que enseñar el motivo, no tragarselo.
export const getTitulos = async () => (await api.get("/titulos")).data;
export const ponerTitulo = async (clave) => (await api.put(`/titulos/${clave}`)).data;
export const getResources = async () => (await api.get("/resources")).data;
export const accessResource = async (id) => (await api.get(`/resources/${id}/access`)).data;
export const purchaseResource = async (id) => (await api.post(`/resources/${id}/purchase`)).data;
// Admin de recursos
export const adminListResources = async () => (await api.get("/admin/resources")).data;
export const adminCreateResource = async (payload) => (await api.post("/admin/resources", payload)).data;
export const adminUpdateResource = async (id, payload) => (await api.patch(`/admin/resources/${id}`, payload)).data;
export const adminDeleteResource = async (id) => (await api.delete(`/admin/resources/${id}`)).data;

export const getAvatarCatalog = async () => (await api.get("/avatar/catalog")).data;
export const getMyAvatar = async () => (await api.get("/avatar/me")).data;
export const saveMyAvatar = async (features) => (await api.put("/avatar/me", { features })).data;
